<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Upcoming Schedules",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Upcoming Schedules",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },                
               
               {
                  text: "Upcoming Schedules",
                  active: true,
               },                     
            ],

            date: new Date().toISOString().split('T')[0],
            
            video_consultation: [
               {start: '09:00:00', end: '11:00:00'},
               {start: '16:00:00', end: '18:00:00'},
            ],
            video_consultation_checked: true,

            home_consultation: [       
            ],
            home_consultation_checked: false,

            clinic_consultation: [
               {start: '11:30:00', end: '13:00:00'},
               {start: '14:00:00', end: '16:00:00'},

            ],
            clinic_consultation_checked: true,           

            start: '',
            end: '',
            type: '',            

            errors: {},


         };
      },
      mounted() {
    
      },

      methods: {        

         addSession() {
            
            if(this.type == 'video') {
               
               this.video_consultation.push({start: this.start, end: this.end});
                  
            } else if(this.type == 'home') {
               
               this.home_consultation.push({start: this.start, end: this.end});
                  
            } else if(this.type == 'clinic') {
               
               this.clinic_consultation.push({start: this.start, end: this.end});
                  
            }
            this.clearSession();
            console.log(this.video_consultation);
            this.$refs['session-modal'].hide();
         },

         clearSession() {
            this.start = '';
            this.end = '';
            this.type = '';
         },

         removeSession(obj, index) {
              obj.splice(index, 1);
         },          
      },
   }
</script>


    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  
                  <!------ Video Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules">                         
                     <h5 class="card-title mb-4">
                        Video Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="video_consultation_checked"/>
                        </div>
                     </h5>                      
                     <div class="row m-0" v-if="video_consultation_checked">
                        <div class="col-12">                                        
                              <div class="row">
                                 <div class="col-lg-10">
                                    <div class="input-tag" v-for="(session, index) in video_consultation" :key="index">
                                       <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}<span @click="removeSession(video_consultation, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                    </div>
                                 </div>
                                 <div class="col-lg-2">                    
                                    <b-button v-b-modal.session-modal variant="success" class="btn-sm float-end me-3" @click="type='video'"><i class="fas fa-plus-circle"></i></b-button>
                                 </div>
                              </div>
                           </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <p>Not scheduled</p>
                        </div>
                     </div>   
                     
                           
                  </b-card>
                  <!------ Video Consultation ends ---------->                          
                  <!------ Home Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules">                         
                     <h5 class="card-title mb-4">
                        Home Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="home_consultation_checked"/>
                        </div>
                     </h5>                      
                     <div class="row m-0" v-if="home_consultation_checked">
                        <div class="col-12">                                        
                              <div class="row">
                                 <div class="col-lg-10">
                                    <div class="input-tag" v-for="(session, index) in home_consultation" :key="index">
                                       <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}<span @click="removeSession(home_consultation, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                    </div>
                                 </div>
                                 <div class="col-lg-2">                    
                                    <b-button v-b-modal.session-modal variant="success" class="btn-sm float-end me-3" @click="type='home'"><i class="fas fa-plus-circle"></i></b-button>
                                 </div>
                              </div>
                           </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <p>Not scheduled</p>
                        </div>
                     </div>   
                     
                           
                  </b-card>
                  <!------ Home Consultation ends ---------->

                  <!------ Clinic Consultation starts ----------> 
                  <b-card header-class="bg-transparent border-light" class="border border-light schedules">                         
                     <h5 class="card-title mb-4">
                        Clinic Consultation                           
                        <div class="form-check form-switch float-end">
                           <input class="form-check-input" type="checkbox"  v-model="clinic_consultation_checked"/>
                        </div>
                     </h5>                      
                     <div class="row m-0" v-if="clinic_consultation_checked">
                        <div class="col-12">                                        
                              <div class="row">
                                 <div class="col-lg-10">
                                    <div class="input-tag" v-for="(session, index) in clinic_consultation" :key="index">
                                       <p>{{ session.start | formatTime }} - {{ session.end | formatTime }}<span @click="removeSession(clinic_consultation, index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                    </div>
                                 </div>
                                 <div class="col-lg-2">                    
                                    <b-button v-b-modal.session-modal variant="success" class="btn-sm float-end me-3" @click="type='video'"><i class="fas fa-plus-circle"></i></b-button>
                                 </div>
                              </div>
                           </div>
                     </div>
                     <div class="row" v-else>
                        <div class="col-12">
                           <p>Not scheduled</p>
                        </div>
                     </div>   
                     
                           
                  </b-card>
                  <!------ Clinic Consultation ends ---------->

               </div>
            </div>
         </div>
      </div>

         <!---- modal starts ---->
         <b-modal ref="session-modal" id="session-modal" title="Add Session" hide-footer @hidden="clearSession()">
            <b-form @submit.prevent="addSession()">                        

               <b-col md="12" class="form-group">
                  <label class="control-label">Start Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="start" locale="en" size="sm"></b-form-timepicker>   -->  
                  <b-form-input v-model="start" type="time"></b-form-input>
               </b-col>

               <b-col md="12" class="form-group">
                  <label class="control-label">End Time<span class="text-danger">*</span></label>
                  <!-- <b-form-timepicker v-model="end" locale="en" size="sm"></b-form-timepicker> -->
                  <b-form-input v-model="end" type="time"></b-form-input>
               </b-col>
                        
               <b-col md="12">
                  <b-button type="submit" class="me-3" variant="primary">OK</b-button>
                  <b-button class="" variant="light" @click="$bvModal.hide('session-modal')">Cancel</b-button>
               </b-col>

            </b-form>
         </b-modal>
         <!---- modal ends ----->

   </Layout>
</template>
